import React, { useState } from "react";
// import About_news from "../../components/blog/about_news";
import { NextSeo } from 'next-seo';
import PageBanner from '@apps/components/pageBanner';
import ThreeAnimation from '@apps/components/three-animation';


const About = () => {
  const metaTitle = "About - Alchemis";
  const metaDesc = `Alchemis is an innovative security firm focusing on block-chain ecosystem. We started from a team with over ten years of cyber security experience to become a global leading block-chain security experts.`;
  const metaImg = `/images/meta/general.png`;
  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <div className={"mt-24"}>
        <ThreeAnimation/>
      </div>
      {/* <!-- Page title --> */}
      <PageBanner text="About Alchemis" description="Alchemis is an innovative security firm focusing on block-chain
              ecosystem. We started from a team with over ten years of cyber security
              experience to become a global leading block-chain security
              experts." image={'/images/about/banner-bg.png'} />
      {/* <!-- Intro / Statistics --> */}

      <section className="pb-24">
        <div className="container">

          {/* <!-- Statistics --> */}
          <div className="pt-24">
            <h2 className="font-display text-jacarta-700 mb-16 text-center text-3xl dark:text-white">
              Our Milestone
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-3">
              <div className="mb-10 text-center">
                <span className="font-display text-jacarta-700 block text-5xl dark:text-accent-gradient">
                  11 +
                </span>
                <span className="dark:text-jacarta-300 block">Year Experience</span>
              </div>
              <div className="mb-10 text-center">
                <span className="font-display text-jacarta-700 block text-5xl dark:text-accent-gradient">
                  100 +
                </span>
                <span className="dark:text-jacarta-300 block">
                  Successful Projects
                </span>
              </div>
              <div className="mb-10 text-center">
                <span className="font-display text-jacarta-700 block text-5xl dark:text-accent-gradient">
                  30 +
                </span>
                <span className="dark:text-jacarta-300 block">
                  Experienced Development Team
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <About_news /> */}
    </>
  );
};

export default About;
